import { useQuery } from "react-query";
import { axiosInstance } from "../../../../utils/axiosInstance";

export const useGetConnectedAccount = ({
  trigger,
  hasOpened,
  setHasOpened,
}: {
  trigger: boolean;
  hasOpened: boolean;
  setHasOpened: (value: boolean) => void;
}) => {
  // Read token once
  const token =
    typeof window !== "undefined"
      ? localStorage.getItem("W2ST_TUTOR_TOKEN")
      : null;

  return useQuery({
    queryKey: ["getConnectedAccount", trigger, token],
    queryFn: async () => {
      if (!token) throw new Error("Token not found");

      const response = await axiosInstance.get("/tutors/stripe/connect", {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    },
    onSuccess: async () => {
      // prevent multiple openings
      if (hasOpened || !token) return;

      try {
        const accountLinkResponse = await axiosInstance.get(
          "/tutors/stripe/account-link",
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const url = accountLinkResponse?.data?.data?.url;
        if (url) {
          window.open(url, "_blank");
          setHasOpened(true); // mark as opened
        }
      } catch (error) {
        console.error("Error handling success flow:", error);
      }
    },
    onError: (error) => {
      console.error("Error fetching user data:", error);
    },
    enabled: trigger && !!token, // only run if trigger is true and token exists
    staleTime: Infinity,
    cacheTime: Infinity,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
